export default __webpack_public_path__ + "static/office-team-06e964eebf5fd070b30de0ba2f449d8e.jpeg";